import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useNavigate } from 'react-router';

const BackNavigation = () => {
    const navigate = useNavigate();

    const handleNavigation = () => {
        if (window.history.length === 0) return navigate('/dashboard');
        navigate(-1);
    };

    return (
        <Button
            className="p-0 back-button-size"
            icon={<ArrowLeftOutlined />}
            type="link"
            onClick={handleNavigation}
        >
            Back
        </Button>
    );
};

export default BackNavigation;
